export default __webpack_public_path__ + "static/media/IMG14.29a65db1.jpg";